import React from "react";
import { MutatingDots } from "react-loader-spinner";
import "../style/colors.scss";
import "../style/typography.scss";

/**
 * Spinner component.
 * @param {Object} props - The component props.
 * @param {number} [props.scale=1] - The scale of the spinner.
 * @param {string} [props.ariaLabel='Loading...'] - The ARIA label for the spinner.
 * @param {string} [props.color='var(--colors-main-2)'] - The color of the spinner.
 * @param {string} [props.secondaryColor='var(--colors-main-3)'] - The secondary color of the spinner.
 * @param {Object} [props.style] - Additional styles for the spinner container.
 * @returns {JSX.Element} The Spinner component.
 */
const Spinner = ({
    scale = 1,
    ariaLabel = "Loading...",
    color = "var(--colors-main-2)",
    secondaryColor = "var(--colors-main-3)",
    style,
}) => {
    const BASE_SIZE = "100px";
    const RADIUS = "15px";

    return (
        <div
            style={{
                transform: "scale(" + scale + ")", // scaling like this instead of directly with with and height cause MutatingDots is squirrely
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                ...style,
            }}
        >
            <MutatingDots
                height={BASE_SIZE}
                width={BASE_SIZE}
                radius={RADIUS}
                color={color}
                secondaryColor={secondaryColor}
                ariaLabel={ariaLabel}
            />
        </div>
    );
};

export default Spinner;
